import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcErrorH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.212 12.774c2.622-4.37 8.955-4.37 11.577 0L65.34 52.028c2.699 4.499-.541 10.222-5.788 10.223H12.45c-5.247 0-8.487-5.724-5.788-10.223zM36.001 48.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m0-24a1.5 1.5 0 0 0-1.5 1.5v18a1.5 1.5 0 0 0 3 0V26a1.5 1.5 0 0 0-1.5-1.5",
    clipRule: "evenodd"
  }));
}
var IcErrorH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcErrorH72));

export { IcErrorH72 as I };
